// extracted by mini-css-extract-plugin
module.exports = {"currency":"currency-2nZAQ","wrapper":"wrapper-SuK45","list":"list-32FXV","list__item":"list__item-yWIPk"};